import { v4 as uuid4 } from 'uuid';

/**
 * One id per page load: a reload, a new tab or a new device all start a new
 * journey. Together with `appointment_short_id` and `user_type` on the
 * Datadog global context it tells "same person, second try" from "same
 * person, same try" in telemetry.
 *
 * Deliberately held in memory only, never in cookies or storage: those are
 * device or tab scoped (`grow_universal_id`, `visitorUuid`).
 */
const journeyId = uuid4();

export function getJourneyId(): string {
  return journeyId;
}
